// Fixed WhatsApp glyph used for `type='whatsapp'` buttons. Path comes
// from the same source the public landing page uses (apps/landing/
// [slug]/page.tsx) so the manager preview and the live page render
// identical icons.
export function WhatsAppIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.6 14.2c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.2-.7.1-.2.3-.8.9-1 1.1-.2.2-.4.2-.7.1-.3-.1-1.2-.4-2.3-1.4-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6.1-.1.3-.4.4-.5.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5 0-.1-.7-1.7-.9-2.3-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1 2.9 1.2 3.1c.1.2 2.1 3.2 5 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.7-.7 2-1.4.2-.7.2-1.3.2-1.4 0-.1-.3-.2-.5-.3zM12 2C6.5 2 2 6.5 2 12c0 1.8.5 3.4 1.3 4.9L2 22l5.3-1.4c1.4.8 3 1.2 4.7 1.2 5.5 0 10-4.5 10-10S17.5 2 12 2z" />
    </svg>
  );
}

// Helpers for round-tripping a WhatsApp click-to-chat URL into the
// pieces the form edits (phone + predefined message).
export function buildWhatsAppUrl(phone: string, message: string): string {
  const params = new URLSearchParams();
  const cleanPhone = phone.replace(/[^\d+]/g, '');
  if (cleanPhone) params.set('phone', cleanPhone);
  if (message) params.set('text', message);
  const qs = params.toString();
  return `https://api.whatsapp.com/send/${qs ? `?${qs}` : ''}`;
}

export function parseWhatsAppUrl(
  url: string,
): { phone: string; message: string } | null {
  try {
    const u = new URL(url);
    if (
      !u.hostname.includes('whatsapp.com') &&
      !u.hostname.includes('wa.me')
    ) {
      return null;
    }
    const phone =
      u.searchParams.get('phone') ?? u.pathname.replace(/^\//, '');
    const message = u.searchParams.get('text') ?? '';
    return { phone, message };
  } catch {
    return null;
  }
}
